<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->
@if (!showTestListTitles) {
    <div class="playtest-session-page">
        @if (showTestCard === PlaytestMenu.playtest) {
            <div class="empty-state-content">
                <div class="font-header4">You don't have any open invites or upcoming Playtests</div>
                <div class="font-body1">
                    Previous Playtests and declined invites can be found in
                    <a class="font-body1-link" (click)="onClickInvites()"><u>Manage invites</u></a>
                </div>
            </div>
        }
        @if (showTestCard !== PlaytestMenu.playtest) {
            <div class="empty-state-content">
                <div class="font-header4">You don't have any declined or past invites</div>
                <div class="font-body1">All of your declined and past invites can be found here.</div>
            </div>
        }
    </div>
}
@if (showTestListTitles) {
    <div class="playtest-session-page">
        @if (showTestCard === PlaytestMenu.playtest && selectedTest) {
            <mat-card appearance="outlined" class="playtest-session-tile">
                <mat-card-content class="card-content">
                    <div class="card-row">
                        <img class="game-thumbnail" src="{{ selectedTest.gameThumbnailUrl }}" />
                        <div class="playtest-session-info">
                            <div class="session-info-content">
                                @if (selectedTest.playStatus === TestState.playnow) {
                                    <div class="playtest-launch">
                                        <div class="font-header6">Join Playtest NOW!</div>
                                        <nv-post-launch-button
                                            [topics]="selectedLearnTopics"
                                            [runs]="getTestRuns(selectedTest)"
                                        ></nv-post-launch-button>
                                        <button
                                            mat-flat-button
                                            color="accent"
                                            class="font-button2 mat-accent"
                                            (click)="onLaunchButtonClicked(selectedTest)"
                                        >
                                            Launch Playtest
                                        </button>
                                    </div>
                                }
                                <div class="font-body2"><strong>Playtest: </strong>{{ selectedTest.testName }}</div>
                                <div class="font-body2">
                                    <strong>{{ hasEndTime(selectedTest) ? 'Time: ' : 'Start Time: ' }}</strong>
                                    {{ selectedTest.startTimeStr }}
                                    @if (hasEndTime(selectedTest)) {
                                        <span> - {{ selectedTest.endTimeStr }} </span>
                                    }
                                </div>
                                <div class="font-body2 playtest-contact">
                                    <strong>Contact: </strong>
                                    <a href="mailto:{{ getCoordinatorEmail(selectedTest) }}">{{
                                        getCoordinatorEmail(selectedTest)
                                    }}</a>
                                </div>
                                @if (selectedTest.notes !== '') {
                                    <mat-expansion-panel
                                        class="playtest-notes-expand"
                                        (opened)="notesExpanded = true"
                                        (afterCollapse)="notesExpanded = false"
                                    >
                                        <mat-expansion-panel-header>
                                            <mat-panel-title
                                                ><div class="font-body2">
                                                    <strong>Notes:&nbsp;</strong>
                                                </div></mat-panel-title
                                            >
                                        </mat-expansion-panel-header>
                                    </mat-expansion-panel>
                                }
                                @if (selectedTest.notes !== '') {
                                    <div
                                        [ngClass]="{
                                            'playtest-notes-content': true,
                                            'playtest-notes-abbr': !notesExpanded
                                        }"
                                        [innerHTML]="selectedTest.notes | trustAsHtml"
                                    ></div>
                                }
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        }
        @if (showTestListTitlesList) {
            <div class="font-body2 playtest-session-list">
                <div class="font-sub2 session-list-header">
                    <div class="list-col list-col-center">
                        <div>Game</div>
                    </div>
                    <div class="list-col list-col-center">
                        <div>Playtest</div>
                    </div>
                    <div class="list-col list-col-center">
                        <div>Date</div>
                    </div>
                    <div class="list-col list-col-center">
                        <div>Contact</div>
                    </div>
                    <div class="list-col list-col-center">
                        <div>Response</div>
                    </div>
                    @if (showTestCard === PlaytestMenu.playtest) {
                        <div class="list-col list-col-center">
                            <div>Status</div>
                        </div>
                    }
                </div>
                <mat-divider></mat-divider>
                @for (test of activeTests; track test) {
                    @if (
                        test.status === 'pending' ||
                        test.status === 'invited' ||
                        test.status === 'accepted' ||
                        (showTestCard === PlaytestMenu.manageInvite && test.status === 'denied')
                    ) {
                        <div
                            [ngClass]="{
                                'session-list-row': true,
                                'session-list-row-selected': test.testId === selectedTest?.testId
                            }"
                            (click)="onSelectTest(test)"
                        >
                            <div class="list-col list-col-start">
                                <div class="font-sub2">{{ test.name }}</div>
                            </div>
                            <div class="list-col list-col-start">
                                <div class="font-body2">{{ test.testName }}</div>
                            </div>
                            <div class="list-col list-col-center">
                                <div class="list-col-date">
                                    <span class="font-body3">{{ test.startTimeStr }}</span>
                                    @if (hasEndTime(test)) {
                                        <span class="font-body3">{{ test.endTimeStr }}</span>
                                    }
                                </div>
                            </div>
                            <div class="list-col list-col-center">
                                <div class="font-body3">{{ getCoordinatorEmail(test) }}</div>
                            </div>
                            <div class="list-col list-col-response">
                                @if (test.testType === PlaytestType.Beta) {
                                    <div class="response-status">
                                        <div class="font-sub3">ACCEPTED</div>
                                    </div>
                                } @else {
                                    @if (test.status === 'pending' || test.status === 'invited') {
                                        <div class="response-spacer-start"><div></div></div>
                                        <div
                                            class="response-action hover-cursor"
                                            (click)="onClickTestResponse(test.testId, 'accept')"
                                        >
                                            <div class="response-action-content">
                                                <mat-icon class="acceptdecline-icon" svgIcon="check"></mat-icon>
                                                <div class="font-sub3">ACCEPT</div>
                                            </div>
                                        </div>
                                        <div class="response-spacer-mid"><div></div></div>
                                        <div
                                            class="response-action hover-cursor"
                                            (click)="onClickTestResponse(test.testId, 'decline')"
                                        >
                                            <div class="response-action-content">
                                                <mat-icon class="acceptdecline-icon" svgIcon="close"></mat-icon>
                                                <div class="font-sub3">DECLINE</div>
                                            </div>
                                        </div>
                                        <div class="response-spacer-end"><div></div></div>
                                    }
                                    @if (test.status === 'accepted') {
                                        <div class="response-status">
                                            <div class="font-sub3">ACCEPTED</div>
                                            <div
                                                class="font-body3-link hover-cursor"
                                                (click)="onClickTestResponse(test.testId, 'toggle')"
                                            >
                                                Change response
                                            </div>
                                        </div>
                                    }
                                    @if (test.status === 'denied') {
                                        <div class="response-status">
                                            <div class="font-sub3">DECLINED</div>
                                            <div
                                                class="font-body3-link hover-cursor"
                                                (click)="onClickTestResponse(test.testId, 'toggle')"
                                            >
                                                Change response
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                            @if (showTestCard === PlaytestMenu.playtest) {
                                <div class="list-col list-col-center">
                                    <div class="font-body2">{{ getTestStatus(test) }}</div>
                                </div>
                            }
                        </div>
                        <mat-divider></mat-divider>
                    }
                }
            </div>
        }
        @if (showTestCard === PlaytestMenu.playtest) {
            <nv-learn-article [topics]="selectedLearnTopics"></nv-learn-article>
        }
    </div>
}
